const devConfig = require("./profiles/dev");
const testConfig = require("./profiles/test");
const uatConfig = require("./profiles/uat");
const prodConfig = require("./profiles/prod");
const demoConfig = require("./profiles/demo");
const localConfig = require("./profiles/local");
const loadtestConfig = require("./profiles/loadtest");

const REACT_APP_API_ENVIRONMENT = process.env.REACT_APP_API_ENVIRONMENT;

let backendHost,
  protocol,
  clientId,
  clientSecret,
  integrationUserEmail,
  integrationUserPassword,
  wsURL,
  storyBool,
  multipleCodebook,
  pdfTronFlag,
  shareCheckboxVisibility,
  ssoEnabled,
  gtUpload,
  ftsJobId,
  highlightEnabled;

let defaultConfig = localConfig.config;

if (REACT_APP_API_ENVIRONMENT === "DEV") {
  defaultConfig = devConfig.config;
} else if (
  /^test/.test(REACT_APP_API_ENVIRONMENT) ||
  REACT_APP_API_ENVIRONMENT === "TEST"
) {
  defaultConfig = testConfig.config;
} else if (REACT_APP_API_ENVIRONMENT === "UAT") {
  defaultConfig = uatConfig.config;
} else if (REACT_APP_API_ENVIRONMENT === "PROD") {
  defaultConfig = prodConfig.config;
} else if (REACT_APP_API_ENVIRONMENT === "DEMO") {
  defaultConfig = demoConfig.config;
} else if (REACT_APP_API_ENVIRONMENT === "LOADTEST") {
  defaultConfig = loadtestConfig.config;
}

backendHost = defaultConfig.API_URL;
protocol = defaultConfig.PROTOCOL;
clientId = defaultConfig.API_CLIENT_ID;
clientSecret = defaultConfig.API_CLIENT_SECRET;
integrationUserEmail = defaultConfig.INTEGRATION_USER_EMAIL;
integrationUserPassword = defaultConfig.INTEGRATION_USER_PASSWORD;
wsURL = defaultConfig.WS_URL;
storyBool = defaultConfig.FULL_STORY_ENABLED;
pdfTronFlag = defaultConfig.PDFTRON_VISIBILITY;
multipleCodebook = defaultConfig.FEATURE_ADMIN_MULTIVERSION_CODEBOOK_ENABLED;
shareCheckboxVisibility = defaultConfig.FEATURE_SHARE_VISIBILITY_ENABLED;
ssoEnabled = defaultConfig.FEATURE_REVIEWER_SSO_ENABLED;
gtUpload = defaultConfig.FEATURE_GT_UPLOAD_ENABLED;
ftsJobId = defaultConfig.FEATURE_FTS_ENABLED_FROM;
highlightEnabled = defaultConfig.FEATURE_HIGHLIGHT_ENABLED;

const API_CONFIG = {
  API_ROOT: backendHost,
  PROTOCOL: protocol,
  API_CLIENT_ID: clientId,
  API_CLIENT_SECRET: clientSecret,
  INTEGRATION_USER_EMAIL: integrationUserEmail,
  INTEGRATION_USER_PASSWORD: integrationUserPassword,
  WS_URL: wsURL,
  LOCAL_REDIRECT: "http://localhost:3000/", //Local SSO redirect URL
  FULL_STORY_ENABLED: storyBool,
  PDFTRON_VISIBILITY: pdfTronFlag,
  FEATURE_ADMIN_MULTIVERSION_CODEBOOK_ENABLED: multipleCodebook,
  FEATURE_SHARE_VISIBILITY_ENABLED: shareCheckboxVisibility,
  FEATURE_REVIEWER_SSO_ENABLED: ssoEnabled,
  FEATURE_GT_UPLOAD_ENABLED: gtUpload,
  FEATURE_FTS_ENABLED_FROM: ftsJobId,
  FEATURE_HIGHLIGHT_ENABLED: highlightEnabled,
};
export default API_CONFIG;
